export default __webpack_public_path__ + "static/media/img46.1a0ab667.jpg";